import { Component, NO_ERRORS_SCHEMA } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-peopleflow-footer',
  standalone: true,
  imports: [],
  schemas: [NO_ERRORS_SCHEMA],
  templateUrl: './peopleflow-footer.component.html',
  styleUrl: './peopleflow-footer.component.scss'
})
export class PeopleflowFooterComponent {
  [key: string]: any;

  constructor(private router:Router){

  }

  goTo(link:any){
   this.router.navigate([link])
}

}
